import Vue from 'vue'
import Router from 'vue-router'
import index from '@/views/index'
import store from '@/store'

import mall from './mall'
import box from './box'



Vue.use(Router)

const router = new Router({

  routes: [
    {
      path: '',
      name: 'index',
      component: index,
      meta: {title: '入口',keepAlive: true, anonymous: true},
      children: [
         {
          path: '/',
          name: 'home',
          component: () => import('@/views/home'),
          meta: {title: '主页',keepAlive: true, anonymous: true},
        },
        {
          path: 'mall',
          name: 'mall',
          component: () => import('@/views/mall/index'),
          meta: {title: '分类',keepAlive: true, anonymous: true},
        },
        {
          path: 'warehouse',
          name: 'warehouse',
          component: () => import('@/views/box/warehouse'),
          meta: {title: '商城',keepAlive: true, anonymous: true}
          
        },
        {
          path: 'mine',
          name: 'mine',
          component: () => import('@/views/mine'),
          meta: {title: '我的',keepAlive: true, anonymous: true},
        },
      ]
    },
    ...mall,
    ...box,
    {
      path: '/login',
      name: 'login',
      component: () => import('@/views/login'),
      meta: {
        anonymous: true,
        keepAlive: false
      }
    },
    {
      path: '/loginverify',
      name: 'loginverify',
      component: () => import('@/views/loginverify'),
      meta: {
        anonymous: true,
        keepAlive: false
      }
    },
    {
      path: '/passwordlogin',
      name: 'passwordlogin',
      component: () => import('@/views/passwordlogin'),
      meta: {
        anonymous: true,
        keepAlive: false
      }
    },
    {
      path: '/register',
      name: 'register',
      component: () => import('@/views/register'),
      meta: {
        anonymous: true,
        keepAlive: false
      }
    },
    {
      path: '/registercode',
      name: 'registercode',
      component: () => import('@/views/registercode'),
      meta: {
        anonymous: true,
        keepAlive: false
      }
    },
    {
      path: '/registerfinish',
      name: 'registerfinish',
      component: () => import('@/views/registerfinish'),
      meta: {
        anonymous: true,
        keepAlive: false
      }
    },
    {
      path: '/verifyIdentidy',
      name: 'verifyIdentidy',
      component: () => import('@/views/verifyIdentidy'),
      meta: {
        anonymous: true,
        keepAlive: false
      }
    },
    {
      path: '/protocol',
      name: 'protocol',
      component: () => import('@/views/protocol'),
      meta: {
        anonymous: true,
        keepAlive: false
      }
    },
    {
      path: '/retrievepaswd',
      name: 'retrievepaswd',
      component: () => import('@/views/retrievepaswd'),
      meta: {
        anonymous: true,
        keepAlive: false
      }
    },
    {
      path: '/about',
      name: 'about',
      component: () => import('@/views/about'),
      meta: {
        anonymous: true,
        keepAlive: false
      }
    },
    {
      path: '/help',
      name: 'help',
      component: () => import('@/views/help'),
      meta: {
        anonymous: true,
        keepAlive: false
      }
    },
    {
      path: '/helpdoc',
      name: 'helpdoc',
      component: () => import('@/views/helpdoc'),
      meta: {
        anonymous: true,
        keepAlive: false
      }
    },
    {
      path: '/cPassword',
      name: 'cPassword',
      component: () => import('@/views/cPassword'),
      meta: {
        anonymous: false,
        keepAlive: false
      }
    },
    {
      path: '/bindphone',
      name: 'bindphone',
      component: () => import('@/views/bindphone'),
      meta: {
        anonymous: false,
        keepAlive: false
      }
    },
    {
      path: '/bindstepone',
      name: 'bindstepone',
      component: () => import('@/views/bindstepone'),
      meta: {
        anonymous: false,
        keepAlive: false
      }
    },
    {
      path: '/bindsteptwo',
      name: 'bindsteptwo',
      component: () => import('@/views/bindsteptwo'),
      meta: {
        anonymous: false,
        keepAlive: false
      }
    },
    {
      path: '/setPaypaswd',
      name: 'setPaypaswd',
      component: () => import('@/views/setPaypaswd'),
      meta: {
        anonymous: false,
        keepAlive: false
      }
    },
    {
      path: '/notice',
      name: 'notice',
      component: () => import('@/views/notice'),
      meta: {
        anonymous: true,
        keepAlive: false
      }
    },
    {
      path: '/noticedetail',
      name: 'noticedetail',
      component: () => import('@/views/noticedetail'),
      meta: {
        anonymous: true,
        keepAlive: false
      }
    },    {
      path: '/invite',
      name: 'invite',
      component: () => import('@/views/invite'),
      meta: {
        anonymous: false,
        keepAlive: false
      }
    }, 
    {
      path: '/invitationrecord',
      name: 'invitationrecord',
      component: () => import('@/views/invitationrecord'),
      meta: {
        anonymous: false,
        keepAlive: false
      }
      
    }
    
    
    
  ]
})

 router.beforeEach((to, from, next) => {
   

  if (to.matched.length == 0) return next({ path: '/404' });
  //如果对象里hasOwnProperty检查包涵meta属性，并且为anonymous为真，或isLogin为真才可以进行下一页操作
  if ((to.hasOwnProperty('meta') && to.meta.anonymous) || store.getters.isLogin()) {
    return next();
  }
  if(from.path==='/login'  && store.getters.isLogin()===false)
  {
    next({ path: '/'});
  }else
  {
    next({ path: '/login', query: { redirect: Math.random() } });
  }
}) 

router.onError((error) => {
  const pattern = /Loading chunk (\d)+ failed/g;
  const isChunkLoadFailed = error.message.match(pattern);
  const targetPath = router.history.pending.fullPath;
  console.log(error.message);
  console.log(targetPath);
  if (isChunkLoadFailed) {
    window.location.replace(window.location.href);
    //  router.replace(targetPath);
  }
});
export default router;




// WEBPACK FOOTER //
// ./src/router/index.js